export const marketoForms = {
  // Done
  REQUEST_CALLBACK: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 8245,
    formElementID: 'mktoForm_8245',
  },
  // Done
  CONTACT_US_TODAY_LOCATION: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 4917,
    formElementID: 'mktoForm_4917',
  },
};

export const MARKETO_FORMS_CONSTANTS = {
  REQUEST_CALLBACK: 'REQUEST_CALLBACK',
  CONTACT_US_TODAY_LOCATION: 'CONTACT_US_TODAY_LOCATION',
};
export const marketoId = '452-UJJ-105';
